module.exports = __webpack_public_path__ + "static/media/logo2.bda193b7.svg";